import React from 'react'
import AuthPage from '../Auth/AuthPage'

// Teacher entry point — the shared screen lives in Components/Auth/AuthPage.
const TeacherLogin = () => <AuthPage role="teacher" />

export default TeacherLogin
